import type { utilisateurs as Fr } from '../fr/utilisateurs';

/** « utilisateurs » in English — typed on the French: a missing sentence does not compile. */
export const utilisateurs: typeof Fr = {
  familles: {
    voir: 'Viewing', creer: 'Data entry', modifier: 'Editing',
    gerer: 'Administration', cloturer: 'Closing', accorder: 'Overrides',
    traiter: 'Approvals', annuler: 'Cancellation', resilier: 'Termination', supprimer: 'Deletion',
  },
  capacites: {
    'voir.planning': 'View the planning board',
    'voir.flotte': 'View vehicles',
    'voir.clients': 'View customers',
    'voir.reservations': 'View rentals',
    'voir.contrats': 'View agreements',
    'voir.caisse': 'View the cash register',
    'voir.analytique': 'View figures and cash flow',
    'voir.journal': 'View the audit log',
    'creer.reservation': 'Create a rental',
    'creer.contrat': 'Draw up an agreement',
    'creer.etatDesLieux': 'Carry out an inspection',
    'creer.mouvementCaisse': 'Take payments and record expenses',
    'creer.client': 'Create a customer record',
    'creer.vehicule': 'Add a vehicle',
    'creer.kilometrage': 'Record odometer readings',
    'creer.entretien': 'Record maintenance or insurance',
    'restituer.caution': 'Refund a deposit to the customer',
    'modifier.reservation': 'Edit a rental',
    'modifier.client': 'Edit a customer record',
    'modifier.vehicule': 'Edit a vehicle',
    'modifier.etatDesLieux': 'Edit an inspection after it is saved',
    'modifier.finance': 'Edit financial data',
    'gerer.taux': 'Set today’s exchange rates',
    'gerer.supplements': 'Set extra charge prices',
    'voir.notes': 'Read the owner’s notes',
    'gerer.notes': 'Write in the owner’s notes',
    'gerer.utilisateurs': 'Manage accounts and permissions',
    'gerer.parametres': 'Edit agency settings',
    'cloturer.caisse': 'Do the end-of-day close',
    'accorder.derogation': 'Grant an eligibility rule override',
    'traiter.correction': 'Decide on a correction request',
    'annuler.reservation': 'Cancel a rental',
    'resilier.contrat': 'Terminate an agreement',
    supprimer: 'Delete',
  },
  droitChange: (c: string, accorde: boolean, nom: string) => `Permission “${c}” ${accorde ? 'granted to' : 'removed from'} ${nom}.`,
  erreur: 'Error',
  titre: 'Users & permissions',
  comptes: (n: number) => `${n} ${n === 1 ? 'account' : 'accounts'}`,
  ajouter: 'Add a user',
  col: { nom: 'Name', email: 'Email', role: 'Role', dernierAcces: 'Last access', etat: 'Status' },
  vous: ' (you)',
  jamais: 'never',
  actif: 'Active',
  desactive: 'Disabled',
  droits: 'Permissions',
  matrice: 'Permission matrix by role',
  capacite: 'Permission',
  note: '“Edit financial data” is ticked only for the owner, and “edit after it is saved” is ticked for no agent: entries being irreversible is your main control mechanism.',
  droitsDe: (n: string) => `${n}’s permissions`,
  aideCoche: 'Ticked = permission granted. A permission that differs from the role is kept as an exception on the user record.',
  exception: 'exception',
  fermer: 'Close',
  nouvel: 'New user',
  nom: 'Name',
  email: 'Email',
  telephone: 'Phone',
  role: 'Role',
  motDePasse: 'Password',
  motDePasseAide: 'At least 6 characters.',
  annuler: 'Cancel',
  creer: 'Create',
};
